<template>

  <div>




    <div class="container">


      <div class="selected-container noTarget" :class="{
            'selected-container disabled': disabled
          }" @mouseenter="showDelete = true" @mouseleave="showDelete = false" @click="onShowList">


        <div class="image-container noTarget"
          :style="'background-color: ' + (selectedItem ? selectedItem.avatarColor : '#008629')">
          <img class="noText noTarget" :src="imgUrl" alt="image"
            :class="type === 'group' ? 'image group' : 'image person'" />
        </div>
        <span class="text noTarget">{{ name }}</span>
        <img v-if="!disabled" src="@/assets/images/dropdown.svg" class="dropdown-img noTarget" alt="dropdown" />

      </div>







      <div v-if="showList" @mouseleave="noDisplay" class="list">


        <div class="list-item" @mouseover="switchLists('person')">
          <text-flow-button-icon name="route_person" />
          <span class="item-name">Route to a person</span>
          <img src="@/assets/images/next.svg" style="width: 7px; height: 12px;" alt="next" />
          <div v-if="hoverPerson" class="list more">
            <div v-for="(item, index) in team" :key="index" class="list-item"
              @click="onClickItemData('route_person', item)">
              <div class="item-avatar" :style="'background-color: ' + item.avatarColor">
                {{ item.avatarName }}
              </div>
              <div class="item-name">
                {{ item.name || item.fullName }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="groups && Array.isArray(groups) && groups.length > 0" class="list-item"
          @mouseover="switchLists('group')">
          <text-flow-button-icon name="route_group" />
          <span class="item-name">
            Route to group
          </span>
          <img src="@/assets/images/next.svg" style="width: 7px; height: 12px;" alt="next" />
          <div v-if="hoverGroup" class="list more" style="top:  90px ">
            <div v-for="(item, index) in groups" :key="index" class="list-item"
              @click="onClickItemData('route_group', item)">
              <div class="item-avatar group" :style="'background-color: ' + item.avatarColor">
                {{ item.avatarName }}
              </div>
              <div class="item-name">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

      

        <div class="list-item" v-if="this.type" @mouseover="noDisplay" @click="onDeleteRoute">


          <div class="item-avatar">
            <img src="@/assets/images/delete.svg" class="delete-img" alt="delete" />


          </div>
          <div class="item-name">
            Delete route
          </div>



        </div>



      </div>




      <div style="display: none" class="list">
        <div v-for="(item, index) in data" :key="index" class="list-item" @click="onClickItem(item)">
          <div class="item-avatar" :class="{
                'item-avatar group': type === 'group'
              }" :style="'background-color: ' + item.avatarColor">
            {{ item.avatarName }}
          </div>
          <div class="item-name">
            {{ item.fullName || item.name }}
          </div>
        </div>

        <div class="list-item" @click="onDeleteRoute">


          <div class="item-avatar">
            <img src="@/assets/images/delete.svg" class="delete-img" alt="delete" />


          </div>
          <div class="item-name">
            Delete route
          </div>



        </div>


      </div>
    </div>

  </div>
</template>

<script>
  import TextFlowButtonIcon from './TextFlowButtonIcon';

  export default {
    name: 'TextFlowDropdown',
    props: {
      type: String,
      data: Array,
      selectedItem: Object,
      team: Array,
      clicked: Number,
      setsClicked: Function,
      groups: Array,
      onSelect: Function,
      dataId: Number,


      keys: Number,
      clicks: String,
      button: String
    },
    data() {
      return {
        showList: false,
        disabled: false,
        showDelete: false,
        hoverPerson: false,
        hoverGroup: false
      };
    },



    computed: {
      imgUrl() {
        const images = require.context('@/assets/images', false, /\.svg$/);
        return images('./' + (this.type ? (this.type != "noassign" ? (this.type == "choose" ? "person" : this.type) : "person") : "person") + '_white.svg');
      },
      name() {

        if (this.type == "choose") {
          return "Choose"
        }



        if (this.type == "noassign") {
          return "Everyone"
        }

        return this.selectedItem ? this.selectedItem.name || this.selectedItem.fullName : 'Choose';
      }
    },
    components: { TextFlowButtonIcon },

    watch: {
      clicked() {
        if (this.clicked != this.dataId) {
          this.showList = false;
        }
        console.log(this.clicked)
      }
    },

    mounted() {
      // if (this.data.length === 1) {
      //   this.$emit('onSelect', this.data[0]);
      //   this.disabled = true;
      // }
    },
    methods: {
      onShowList() {
        this.showList = !this.showList;

        this.$emit("setsClicked", this.dataId)
      },
      onClickItem(item) {
        this.showList = false;
        this.$emit('onSelect', item);
      },
      onData() {
        console.log(this.type)
      },
      noContent() {
        this.showList = false;
      },
      onClickItemData(item, data) {
        this.showList = false;
        this.hoverPerson = false;
        this.hoverGroup = false;


        this.onSelect(item, data, this.type, this.dataId);
      },
      switchLists(listType = '') {
        if (listType === 'person') {
          this.hoverGroup = false;
          return (this.hoverPerson = true);
        }
        this.hoverGroup = true;
        return (this.hoverPerson = false);
      }
      ,
      noDisplay() {
        this.hoverGroup = false;
        this.hoverPerson = false;




      },
      onDeleteRoute() {
        this.showList = false;
        this.$emit('onDelete', this.dataId);
      }
    }
  };
</script>

<style scoped lang="scss">
  .container {
    position: relative;
  }

  .selected-container {
    width: 240px;
    height: 70px;
    background: #ffffff;
    box-shadow: 0px 2px 10px rgba(83, 95, 119, 0.15);
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 20px 0 10px;
    cursor: pointer;

    &.disabled {
      cursor: unset;
    }

    .image-container {
      width: 50px;
      height: 50px;
      background: #008629;
      box-shadow: 0px 0px 2px rgba(78, 78, 78, 0.4);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .image {
        &.group {
          width: 54px;
          height: 35px;
        }

        &.person {
          width: 40px;
          height: 40px;
          margin-top: 3px;
        }
      }
    }

    .text {
      flex: 1;
      font-weight: 500;
      font-size: 19px;
      line-height: 20px;
      letter-spacing: -0.01em;
      color: #626c82;
      margin-left: 25px;
      display: flex;
      height: auto;
    }

    .dropdown-img {
      width: 14px;
      height: 14px;
    }

    .delete-img {
      position: absolute;
      top: 0;
      right: 2px;
    }
  }

  .list {
    position: absolute;
    left: 85px;
    top: 55px;
    width: 225px;
    max-height: 197px;
    background: #ffffff;
    border: 0.2px solid #d4d6d8;
    box-shadow: 2px 2px 10px rgba(83, 95, 119, 0.15);
    border-radius: 8px;
    padding: 10px 0;

    z-index: 9;

    .list-item {
      width: 100%;
      height: 45px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      padding: 0 15px;

      &:hover {
        background-color: $colorBack;
      }

      .item-avatar {
        width: 20px;
        height: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        letter-spacing: 0.03em;
        color: #ffffff;

        &.group {
          border-radius: 5px;
        }
      }

      .item-name {
        flex: 1;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.01em;
        margin-left: 15px;
        color: $colorText;
      }
    }
  }

  .delete-img {
    width: 20px;
    height: 20px;
  }

  .noContent {
    position: fixed;
    left: 0vw;
    top: 0vh;
    width: 100vw;
    height: 100vh;
  }
</style>